import { createPortal } from 'react-dom';

import { Message } from 'types/message';
import { cn } from 'utils';
import Text from '../Text';

import { XOutlineIcon } from 'assets/svgs';

type DeleteFn = (index: number) => void;

interface MessageBoxProps extends Message {
  onClickDelete: DeleteFn;
}

interface MessageWrapperProps {
  messageArray: Message[];
  onClickDelete: DeleteFn;
}

const MessageBox = ({ index, icon, text, bgClassName = 'bg-[#2AC111]', onClickDelete }: MessageBoxProps) => {
  return (
    <div
      className={cn(
        bgClassName,
        'flex w-full max-w-[90vw] sm:max-w-sm flex-row items-center justify-between gap-2 rounded-lg px-4 py-2',
        '[&>svg]:h-4 [&>svg]:w-4 [&_path]:stroke-white'
      )}
    >
      {icon}
      <Text className="flex-1" color="white">
        {text}
      </Text>
      <button className="h-4 w-4" type="button" onClick={() => onClickDelete(index)}>
        <XOutlineIcon className="h-4 w-4 [&_path]:stroke-white" />
      </button>
    </div>
  );
};

const MessageWrapper = ({ messageArray, onClickDelete }: MessageWrapperProps) => {
  return (
    <div className="fixed right-10 top-3 z-50 flex flex-col gap-2">
      {messageArray.map((message, index) => (
        <MessageBox key={index} {...message} onClickDelete={onClickDelete} />
      ))}
    </div>
  );
};

const InfoMessage = ({ messageArray, onClickDelete }: MessageWrapperProps) => {
  const messageArea = document.getElementById('message-area');
  return createPortal(
    <MessageWrapper messageArray={messageArray} onClickDelete={onClickDelete} />,
    messageArea as HTMLElement
  );
};

export default InfoMessage;
